import React from "react";
import Noimg from "../images/no_img.jpg";
import tw from "twin.macro";

// eslint-disable-next-line
const Heading = tw.h1`text-center`;

export default function OrderDetails({ viewCart, total }) {
  return (
    <div className="col-md-12 my-sm-0 my-4">
      <div
        className="ej-order-summary"
        style={{
          padding: "12px",
          fontSize: "13px",
          maxWidth: "300px",
        }}
      >
        <h3 className="ej-title">Order Summary</h3>

        {/* Items */}
        {viewCart.map((item, i) => (
          <div
            key={i}
            className="ej-order-item"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            <img
              src={
                item.images === "Image_Not_Available" ||
                item.images === "-" ||
                item.images === null ||
                item.images === "@#@"
                  ? Noimg
                  : item.images?.split("@#@")[0]
              }
              alt=""
              style={{
                width: "70px",
                height: "70px",
                objectFit: "cover",
                borderRadius: "6px",
              }}
            />

            <div style={{ flex: 1 }}>
              <p
                className="ej-item-name"
                style={{ fontSize: "13px", margin: 0 }}
              >
                {item.productName}
              </p>
              <span className="ej-item-code" style={{ fontSize: "11px" }}>
                {item.productCode}
              </span>
              {/* <span className="ej-item-qty" style={{ fontSize: "11px" }}>Qty: 1</span> */}
            </div>
            <h4
              className="ej-item-price"
              style={{ fontSize: "13px", margin: 0 }}
            >
              ₹ {Math.trunc(item.total)}
            </h4>
          </div>
        ))}

        {/* Summary */}
        <div className="ej-summary-row">
          <span>Subtotal</span>
          <span>₹ {Math.trunc(total).toLocaleString("en-IN")}</span>
        </div>

        <div className="ej-summary-total">
          <span>Total Cost</span>
          <span>₹ {Math.trunc(total).toLocaleString("en-IN")}</span>
        </div>
      </div>
    </div>
  );
}
